// extracted by mini-css-extract-plugin
export var wordContainer = "_ob-0";